module.exports = __webpack_public_path__ + "assets/settings.03e0d2f9.svg";